import React, { MouseEventHandler, PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from './Button.module.scss';

export const Button = ({
    children, onClick, title,
    className, disabled, small,
    style = 'primary'
}: ButtonProps) => {

    const classes = classNames(className, styles.button, 'idt-button', 'idt-button--' + style, {
        'idt-button--small': small,
        'idt-button--disabled': disabled
    });

    const handleClick: React.MouseEventHandler = (event) => {
        if (!disabled && onClick) {
            onClick(event);
        }
    };

    return (
        <div onClick={handleClick} className={classes} title={title}>
            {children}
        </div>
    );
};

type ButtonStyles = 'primary' | 'outline' | 'ghost' | 'white' | 'danger' | 'depressed' | 'fotofun' | 'smallest';

export type ButtonProps = PropsWithChildren<{
    onClick?: MouseEventHandler;
    className?: string;
    small?: boolean;
    disabled?: boolean;
    title?: string;
    style?: ButtonStyles;
}>;